<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品添加
    -->
  <div class="product-add">
    <el-tabs v-model="activeName">
      <el-tab-pane label="基础" name="basic"></el-tab-pane>
      <el-tab-pane label="详情" name="content"></el-tab-pane> <!-- spec -->
     </el-tabs>
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <!--基础信息-->
      <Basic v-if="activeName == 'basic'" :type="'add'"></Basic>

      <!--规格设置-->
      <Spec v-if="activeName === 'spec'"></Spec>

      <!--商品详情-->
      <Content v-if="activeName === 'content'"></Content>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">发布</el-button>
        <el-button size="small" type="primary" @click="Draft" :loading="loading">保存为草稿</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Basic from './part/Basic.vue';
import Spec from './part/Spec.vue';
import Content from './part/Content.vue';
import BuySet from './part/Buyset.vue';
import Storage from './part/Storage.vue';
import Attr from './part/attr.vue';
import Commission from './part/Commission'
import Auth from './part/Auth'

export default {
  components: {
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    /*高级设置*/
    BuySet,
    // 商品属性
    Attr,
    // 分销模块
    Commission,
    // 商品购买权限
    Auth,
    Storage,
  },
  data() {
    return {
      
      activeName: 'basic',
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        supplySetting:{
          is_supply:false,
        },
        model: {
          clerk:{
            real_name:""
          },
          supply_id:0,
          supply:{},
          /*商品名称*/
          product_name: '',
          // 商品模板
          page_id:0,
          // 商品类型值
          product_type_value:'商品',
          /*商品编码*/
          product_no: '',
          /*商品内部编码*/
          product_diy_no: '',
          province_id: '',
          city_id: '',
          /*商品分类- 平台*/
          category_id: null,
          /*商品分类- 商家/供应商*/
          supply_category_id: null,
        
          /*商品类型*/
          type: 'product',
          /*商品图片*/
          image: [],
          /*商品卖点*/
          selling_point: '',
          /*规格类别,默认10单规格，20多规格*/
          spec_type: 10,
          /*库存计算方式,默认20付款减库存，10下单减库存*/
          deduct_stock_type: 20,
          /*检查用户等级*/
          is_alone_grade: 0,
          sku: {
            stock_num: 100
          },
          /*多规格类别*/
          spec_many: {
            /*多规格类别*/
            spec_attr: [],
            /*多规格表格数据*/
            spec_list: []
          },
          /*商品详情内容*/
          content: '',
          /*运费模板ID*/
          delivery_id: '',
          /*商品状态*/
          product_status: 10,
          // 商品链接状态
          link_status: 2,
          /*初始销量*/
          sales_initial: 0,
          /*商品排序，默认100*/
          product_sort: 100,
          /*是否开启积分赠送,默认1为开启，0为关闭*/
          is_points_gift: 0,
          /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
          is_points_discount: 0,
          /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
          is_enable_grade: 1,
          /*是否开启单独分销,默认0为关闭，1为开启*/
          is_ind_agent: 0,
          /*分销佣金类型,默认10为百分比，20为固定金额*/
          agent_money_type: 10,
          /*一级佣金*/
          first_money: null,
          /*二级佣金*/
          second_money: null,
          /*三级佣金*/
          third_money: null,
          /*按钮名称 */
          mini_name: '',
          /* 小程序id */
          mini_appid: '',
          /* 跳转页面 */
          mini_page: '',
          /* 商品直推佣金 */
          direct_commission: 0,
          /*是否虚拟商品*/
          is_virtual: 0,
          is_special_view: 0,
          /*编码批次*/
          code_product_open: 0,
          /*开启云仓配送*/
          open_storage: 0,
          /*强制开启云仓配送*/
          force_open_storage: 0,
          // 平台链接
          link: '',
          // 备注
          remark: '',
          // 是否上下架
          automatic_shelves: 0,
          // 上下架时间
          shelves_time: [],
          //预售时间
          sale_time: '',
          //发货时间
          delivery_time: '',
          setting: {
            buy_auth: {
              show_price_id: [],
              buy_auth_id: [],
              tips: '无权限',
              name: '跳转连接',
              linkUrl: '',
              // 每月限购数量
              monthLimit: '',
            },
            text: {
              buy_text: '立即购买',
            }
          },
          commission_type: [],
          delivery_type: [],
          independent_commission: [],
          poster: '',
          video: '',
          subtitle: '',
          list: [],
          attr_type: '',
          grade_model: 0,
          is_level_difference: 0,
          lateral_ratio: 0,
        },
        /*商品分类*/
        catgory: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        /*规格数据*/
        specData: null,
        product_del_ids: [],
        tableData: [],
        // 标签
        labelList: [],
        product_label_del_ids: [],
        /*是否锁住*/
        isSpecLocked: false,
        product_vars: [],
        storage_vars: [],
        commission_list: [],
        all_type: [],
        supply_price_name: "成本价",
        // 限制购买
        buy_limit: 0,
        // 商品业绩
        achievement: 0,
        // 商品起购数
        buy_num: 0,
        show_delivery:[]
      }
    };
  },
  provide: function () {
    return {
      form: this.form
    }
  },
  created() {
    /*获取基础数据*/
    this.getBaseData();

  },
  methods: {

    /*获取基础数据*/
    getBaseData: function () {
      let self = this;
      PorductApi.getBaseData({}, true)
        .then(res => {
          self.loading = false;
          Object.assign(self.form, res.data);
          if (res.data.delivery) {
            self.form.model.delivery_id = res.data.delivery[0].delivery_id
          }
          if (!self.form.product_vars.product_no_text) {
            self.form.product_vars.product_no_text = '商品编码';
          }
          if (!self.form.product_vars.product_diy_no_text) {
            self.form.product_vars.product_diy_no_text = '商品自编码';
          }
          if (!self.form.supply) {
            self.form.no_supply = true
          } else {
            self.form.no_supply = self.form.supply.self_manage > 0 ? true : false;
            var supplySetting = self.form.supply.kmd_grade.setting
            supplySetting.is_supply = true;
            self.form.supplySetting = supplySetting
          }
          if (res.data.model.setting) {
            self.form.buy_auth = res.data.model.setting.buy_auth;
          }

          self.form.storage_vars = res.data.storage_vars;
          self.form.grade_list = res.data.gradeList;
          self.form.commission_list = res.data.commission_list;
          self.form.all_type = res.data.all_type;
          self.form.supply_price_name = self.form.no_supply ? '成本价' : '供货价';
          self.form.product_vars.product_no_text += "：";
          self.form.product_vars.product_diy_no_text += "：";
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list, type) {
      let obj = {};
      if (type == 2) {
        list.forEach(item => {
          obj[item.grade_id] = item.product_fixed;
        });
      } else if (type == 1) {
        list.forEach(item => {
          obj[item.grade_id] = item.product_equity;
        });
      } else if (type == 20) {
        list.forEach(item => {
          obj[item.grade_id] = item.independent_commission;
        });
      }else if(type == 30){
        list.forEach(item => {
          if(item.product_lateral_ratio){
            obj[item.grade_id] = item.product_lateral_ratio;
          }else{
            obj[item.grade_id] = 0;
          }
        
        });
       
      }
      return JSON.stringify(obj);
    },

    /*提交*/
    onSubmit: function () {
      let self = this;
      let params = self.form.model;
      self.$refs.form.validate(valid => {
        if (valid) {
        

          if(params.delivery_type.length <=0){
            self.$message({
                message: '请选择配送方式',
                type: 'error'
              });
            return
          }
          self.loading = true;
          params.alone_grade_equity = self.convertJson(self.form.gradeList, params.is_alone_grade);
          params.relation_product = self.form.tableData;
          params.relation_label = self.form.labelList;
          params.independent_commission = self.convertJson(self.form.gradeList, params.agent_type);
          params.lateral_ratio = self.convertJson(self.form.gradeList, 30);
          PorductApi.addProduct(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.$router.push('/product/product/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.product_status = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }

  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/add.vue